import {Component, OnInit} from '@angular/core';
import {NavParams, Platform, ViewController} from 'ionic-angular';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'dynamic-select-options',
  templateUrl: 'dynamic-select.options.html'
})

export class DynamicSelectOptions implements OnInit {

  options: Array<{ label: string, value: any }>;
  title: string;
  color: string;
  search: string = '';
  isAndroid: boolean;

  constructor(private translate: TranslateService,
              private navParams: NavParams,
              private platform: Platform,
              private viewCtrl: ViewController) {
    this.initVars();
  }

  ngOnInit() {
    this.registerBackButtonAction();
  }

  registerBackButtonAction() {
    this.platform.registerBackButtonAction(() => {
      this.viewCtrl.dismiss();
    });
  }

  initVars() {
    this.isAndroid = this.platform.is('android');
    this.title = this.navParams.get('title') || this.translate.instant('dynamicSelect.options.title');
    this.color = this.navParams.get('color') || 'cycleCountGreen';
    this.options = this.navParams.get('options');

    this.options.sort((option1, option2) => {
      if (option1.label < option2.label) return -1;
      if (option1.label > option2.label) return 1;
      return 0;
    });
  }

  select(option: { label: string, value: any }) {
    this.viewCtrl.dismiss(option);
  }

  cancel() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/dynamic-select/dynamic-select.options.ts